import COS from 'cos-js-sdk-v5'
import SparkMD5 from 'spark-md5'
// import { getCOSAuth } from '@/axios/api'
import material from "@/api/material";

var key = ''
// 配置
const cosConfig = {
    Bucket: 'ad-1310029615',
    Region: 'ap-chongqing',
    Domain: 'store-ad.dwenton.com'
}

// 初始化实例
// var obs = JSON.parse(sessionStorage.getItem('obs'))
var cos = new COS({
    getAuthorization: async function (options, callback) {
        /**
         * 签名计算放在前端会暴露 SecretId 和 SecretKey
         * 我们把签名计算过程放在后端实现，前端通过 ajax 向后端获取签名结果
         * 正式部署时请再后端加一层自己网站本身的权限检验。 
         * 异步获取临时密钥
         */
        const obs = await material.getSessionToken()
        // const authdata = res.data.response
        const auth = {
            // TmpSecretId: authdata.credentials.tmpSecretId,
            TmpSecretId: obs.data.tmpSecretId,
            // TmpSecretKey: authdata.credentials.tmpSecretKey,
            TmpSecretKey: obs.data.tmpSecretKey,
            XCosSecurityToken: obs.data.sessionToken,
            ExpiredTime: obs.data.expiredTime // 在ExpiredTime时间前，不会再次调用getAuthorization
        }
        callback(auth)
    },
    FileParallelLimit: 3, // 文件并发数
    ChunkParallelLimit: 8, // 同一个上传文件的分块并发数
    ChunkSize: 1024 * 1024 * 8 // 分块上传时，每块的字节数大小
})
// var obs = JSON.parse(sessionStorage.getItem('obs'))
// console.log(obs.tmpSecretId)
// var cos = new COS({
//     SecretId: obs.tmpSecretId,
//     // SecretId: 'AKIDsoeYKIC3tenpmbHrRuGf5MdyGXvIiEhK',
//     SecretKey: obs.tmpSecretKey,
//     // SecretKey: 'nhfcI3k5OWfL9tjMF92qS1UrAY0PVcmu',
// });

// 获取cos存储的图片地址，替换为域名地址
function getObjectUrl() {
    const url = cos.getObjectUrl({
        Bucket: cosConfig.Bucket,
        Region: cosConfig.Region,
        Key: key,
        Sign: false
    }, function (err, data) {
        // console.log(err || data)
    })
    // 腾讯云的地址替换为域名地址
    const p = `${cosConfig.Bucket}.cos.${cosConfig.Region}.myqcloud.com`
    // console.log(url.replace(p, cosConfig.Domain), 'url.replace(p, cosConfig.Domain)')
    return url.replace(p, cosConfig.Domain)
}

// 获得文件md5
function getFileMD5(file, callback) {
    // 声明必要的变量
    const fileReader = new FileReader()
    // 文件每块分割2M，计算分割详情
    const chunkSize = 2 * 1024 * 1024;
    const chunks = Math.ceil(file.size / chunkSize)
    let currentChunk = 0

    // 创建md5对象（基于SparkMD5）
    const spark = new SparkMD5()

    // 每块文件读取完毕之后的处理
    fileReader.onload = function (e) {
        // 每块交由sparkMD5进行计算
        spark.appendBinary(e.target.result)
        currentChunk++

        // 如果文件处理完成计算MD5，如果还有分片继续处理
        if (currentChunk < chunks) {
            loadNext()
        } else {
            callback(spark.end())
        }
    }

    // 处理单片文件的上传
    function loadNext() {
        const start = currentChunk * chunkSize
        const end = start + chunkSize >= file.size ? file.size : start + chunkSize

        fileReader.readAsBinaryString(file.slice(start, end))
    }

    loadNext()
}

// 大文件分片上传-通过sliceUploadFile上传
export function uploadFile(file, callback, progressBc) {
    // 得到md5码
    getFileMD5(file, md5 => {
        // 存储文件的md5码
        file.md5 = md5
        const subfix = file.name.substr(file.name.lastIndexOf('.'))
        key = file.md5 + subfix;
        cos.sliceUploadFile({
            Bucket: cosConfig.Bucket,
            Region: cosConfig.Region,
            Key: key,
            Body: file,
            onProgress: function (progressData) {
                console.log(progressData.percent, 'progressData.percent')
                progressBc(progressData.percent)
            }
        }, function (err, data) {
            if (err) {
                callback(err)
            } else {
                console.log(data, '8888=============')
                data.fid = getObjectUrl()
                // console.log(data)
                // if (data.fid.split('.')[data.fid.split('.').length - 1] === 'mp4') {
                //     getVideoScreenShot(data.Key)
                // }
                callback(null, data)
            }
        })
    })
}

// 小文件直接上传-通过putObject上传
export function uploadFile2(file, callback, progressBc) {
    // 得到md5码
    getFileMD5(file, md5 => {
        // 存储文件的md5码
        file.md5 = md5
        const subfix = file.name.substr(file.name.lastIndexOf('.'))
        key = file.md5 + subfix
        cos.headObject({
            Bucket: cosConfig.Bucket,
            Region: cosConfig.Region,
            Key: key
        }, function (err, data) {
            if (err != null) {
                cos.putObject({
                    Bucket: cosConfig.Bucket,
                    Region: cosConfig.Region,
                    Key: key,
                    Body: file,
                    onProgress: function (progressData) {
                        // console.log(JSON.stringify(info))
                        progressBc(progressData.percent)
                    }
                }, (err, data) => {
                    if (err && err.error) {
                        // wx.showModal({ title: '返回错误', content: '请求失败：' + err.error.Message + '；状态码：' + err.statusCode, showCancel: false });
                    } else if (err) {
                        // wx.showModal({ title: '请求出错', content: '请求出错：' + err + '；状态码：' + err.statusCode, showCancel: false });
                    } else {
                        callback(key)
                        //  wx.showToast({ title: '上传成功', icon: 'success', duration: 3000 });
                    }
                })
            } else if (data != null) {
                callback(key)
            }
        })
    })
}

//获取视封面
export function getVideoScreenShot(key, callback) {
    cos.request({
        Bucket: cosConfig.Bucket,
        Region: cosConfig.Region,
        Method: 'GET',
        Key: key,  /* 存储桶内的媒体文件，必须字段 */
        Query: {
            'ci-process': 'snapshot', /** 固定值，必须 */
            time: 1, /** 截图的时间点，单位为秒，必须 */
            format: 'jpg'
        },
        RawBody: true
    },
        (err, data) => {
            console.log(data, 'data')
            if (data && data.statusCode == 200) {
                console.log(data, '7777777777777777777770000000000000')
                callback(data) // 返回图片链接地址和视频的原始名称
            } else {
                console.log('失败', err)
                // Message({ message: '查询视频第一帧截图失败！', type: 'error' })
            }
        }
    )
}


// 获取视频第一帧截图和视频时长
export async function getVideoImg(url) {
    // obsClient = await init();
    let name = randomString(10) + '.png';
    return new Promise(function (resolve, reject) {
        let dataURL = '';
        let duration = '';
        // let name = randomString(10)+'.png';
        let video = document.createElement('video');
        video.setAttribute('crossOrigin', 'anonymous');// 处理跨域
        video.setAttribute('src', url);
        video.setAttribute('width', video.width);
        video.setAttribute('height', video.height);
        video.setAttribute('preload', 'auto');
        // console.log(video.width,video.height);
        video.addEventListener('loadedmetadata', async function () {
            // console.log('iiiiiiiiiii',video.duration);
            duration = video.duration;
            await video.addEventListener('loadeddata', async () => {
                let canvas = document.createElement('canvas');
                let width = 300; // canvas的尺寸和图片一样
                let height = 150;
                canvas.width = width;
                canvas.height = height;
                canvas.getContext('2d').drawImage(video, 0, 0, width, height); // 绘制canvas
                dataURL = canvas.toDataURL('image/png'); // 转换为base64
                // console.log(dataURL,'dataURL');
                let blob = dataURLtoBlob(dataURL);
                let file = blobToFile(blob, randomString(12) + '.png');
                // console.log(file,'file');
                let data = {
                    firstImgUrl: '',
                    duration: duration
                };
                // console.log(file, '0000000000000999')
                data.firstImgUrl = await uploadFile(file, (err, data) => {
                    if (err) {
                        console.log(err);
                    } else {
                        // console.log(data, "0000777");
                        data.duration = duration
                        resolve(data);
                    }
                });
                // console.log(data,'data');
                // resolve(data);
            });
        });

    });
}

// 将base64转换为blob
function dataURLtoBlob(dataURI) {
    let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]; // mime类型
    let byteString = atob(dataURI.split(',')[1]); // base64 解码
    let arrayBuffer = new ArrayBuffer(byteString.length); // 创建缓冲数组
    let intArray = new Uint8Array(arrayBuffer); // 创建视图

    for (let i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([intArray], { type: mimeString });
}
// 将blob转换为file
function blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
}

// 第一帧截图随机名字
function randomString(len) {
    len = len || 32;
    let timestamp = new Date().getTime();
    /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    let maxPos = $chars.length;
    let randomStr = '';
    for (let i = 0; i < len; i++) {
        randomStr += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return randomStr + timestamp;
}